import { fetcher } from '@commenda/utils';

import { TBillingRenewalUatFixtureScenario } from './types';

export interface PrepareBillingRenewalFixtureParams {
  scenario: TBillingRenewalUatFixtureScenario;
}

export const prepareBillingRenewalFixture = async (
  quoteId: string,
  body: PrepareBillingRenewalFixtureParams
) =>
  fetcher(`commenda-billing/quotes/${quoteId}/renewal-test-fixtures`, {
    method: 'POST',
    body,
  });
